<template>
  <div id="chart">
    <ApexChart
      type="bar"
      height="100%"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import ApexChart from "vue3-apexcharts";

const props = defineProps({
  data: {
    type: Array,
    required: true,
    default: () => [
      { label: "Silvina Ines Ribba", values: [50, 50] },
      { label: "Mariela Teresa Tello", values: [35, 65] },
      { label: "Alicia Raquel Luque", values: [30, 20] },
      { label: "Graciela Viviana Berridi", values: [55, 45] },
    ],
  },
  colors: {
    type: Array,
    default: () => ["rgba(0, 143, 251, 1)", "rgba(0, 227, 150, 1)"],
  },
  stackLabels: {
    type: Array,
    default: () => ["Valor A", "Valor B"],
  },
});

// Preparar series
const series = computed(() =>
  props.stackLabels.map((label, index) => ({
    name: label,
    data: props.data.map((item) => item.values[index]),
  }))
);

// Opciones del gráfico
const chartOptions = computed(() => ({
  chart: {
    type: "bar",
    height: 400,
    stacked: true,
    toolbar: { show: false },
  },
  tooltip: {
    enabled: false,
  },
  // Bloque para deshabilitar el cambio de color al pasar el mouse
  states: {
    hover: {
      filter: {
        type: "none", // Deshabilita cualquier filtro de hover
      },
    },
    active: {
      filter: {
        type: "none", // Deshabilita el filtro de los clics (opcional)
      },
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      //columnWidth: "60%",
      columnWidth: "35px",
      barHeight: "80%",
      //borderRadius: 6,
      dataLabels: {
        total: {
          enabled: true,
          // Muestra el total de la barra arriba
          formatter: function (val) {
            return `${val}`;
          },
          style: {
            fontSize: "0.75rem",
            fontWeight: "600",
            color: "#333",
            fontFamily: "Poppins, sans-serif",
          },
        },
      },
    },
  },
  colors: props.colors,
  dataLabels: {
    enabled: true,
    formatter: function (val, opts) {
      // Calcula el total de la barra
      const total = opts.w.globals.stackedSeriesTotals[opts.dataPointIndex];
      const percentage = ((val / total) * 100).toFixed(0); // Redondea
      return `${percentage}%`;
    },
    style: {
      fontSize: "0.625rem",
      fontWeight: "500",
      colors: ["var(--bg-popup)"],
      fontFamily: "Poppins, sans-serif",
    },
    offsetY: -3,
  },
  xaxis: {
    categories: props.data.map((item) => item.label),
    labels: {
      style: {
        fontSize: "12px",
        fontWeight: 600,
        colors: "#333",
      },
      // Formatea las etiquetas del eje X para que quepan
      formatter: function (value) {
        const words = value.split(" ");
        if (words.length <= 1) return value;
        return words.map((word, index) =>
          index % 2 === 0 ? word : `${word}\n`
        );
      },
    },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  yaxis: { show: false },
  grid: { show: false },
  legend: {
    show: false,
    position: "top",
    horizontalAlign: "center",
  },
}));
</script>

<style scoped>
#chart {
  background: transparent;
  width: 100%;
  height: 100%;
  min-height: 0;
}
/* El div generado por vue-apexcharts */
.vue-apexcharts {
  height: 100%;
  min-height: 0;
}
</style>
